<template>
<div>
    <Navigation :fullwidth="true"></Navigation>
    

	<div class="container margin_60_35">
		
        <Loader :show="loading"></Loader>

        <div class="container" v-if="action=='send-code'">
            <div class="row justify-content-md-center">
                <div class="box_general col-5 ">

                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Recuperar contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <div class="form-group mb-0">
                                <label>Ingresá tu email para recuperar la contraseña</label>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <input  
                                    type="text"
                                    class="form-control" 
                                    placeholder="Email" 
                                    v-model="form.email" 
                                    :class="{'is-invalid':validationErrors['general']}"
                                    >
                                <div class="invalid-feedback">{{validationErrors['general']}}</div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-sm pull-right btn-success" @click="forgotPasswordSend()">Continuar</button>
                            <router-link tag="button" class="btn btn-sm pull-left" to="/login">Volver</router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="container" v-if="action=='code-sended'">
            <div class="row justify-content-md-center">
                <div class="box_general col-5 ">

                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Recuperar contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <p>Te hemos enviado un correo con las instrucciones para reestablecer tu contraseña.</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        
        
        <div class="container" v-if="action=='reset-password'">
            <div class="row justify-content-md-center">
                <div class="box_general col-5 ">

                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Establecer nueva contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <div class="form-group mb-0">
                                <label>Contraseña nueva</label>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <div class="input-float-button" @click="showPassword=!showPassword">
                                    <i class="" :class="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
                                </div>
                                <input  
                                    :type="showPassword ? 'text' : 'password'"
                                    class="form-control" 
                                    placeholder="Contraseña nueva" 
                                    v-model="form.passwordNew" 
                                    :class="{'is-invalid':validationErrors['data.passwordNew']}"
                                    >
                                <password 
                                    v-model="form.passwordNew"
                                    @score="passwordScore"
                                    :strength-meter-only="true"
                                    @feedback="showPasswordFeedback"
                                />
                                <div class="password-feedback text-danger" v-if="form.passwordNew.length>0 && passwordStrength==0"> Contraseña demasiado debil</div>
                                <div class="password-feedback text-warning" v-if="passwordStrength==1 || passwordStrength==2"> Recuerda utilizar combinaciones de mayúsculas, minúsculas y números.</div>
                                <div class="password-feedback text-success" v-if="passwordStrength==3"> Hasta aquí bien, pero un poco más de seguridad nunca viene mal.</div>
                                <div class="password-feedback text-success" v-if="passwordStrength==4"> Excelente.</div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="form-group mb-0">
                                <label>Confirmar contraseña</label>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <div class="input-float-button" @click="showPassword=!showPassword">
                                    <i class="" :class="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
                                </div>
                                <input  
                                    :type="showPassword ? 'text' : 'password'"
                                    class="form-control" 
                                    placeholder="Confirmar contraseña" 
                                    v-model="form.passwordNewConfirm" 
                                    :class="{'is-invalid':validationErrors['data.passwordNewConfirm']}"
                                    >
                                <div class="invalid-feedback">{{validationErrors['data.passwordNewConfirm']}}</div>
                            </div>
                        </div>
                        
                        <div class="col-12" v-if="validationErrors['resettingPasswordError']">
                            <div class="alert alert-danger">{{validationErrors['resettingPasswordError']}}</div>
                        </div>

                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-sm pull-right btn-success" @click="resetPasswordSend">Cambiar contraseña</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="container" v-if="action=='password-updated'">
            <div class="row justify-content-md-center">
                <div class="box_general col-5 ">

                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Contraseña actualizada</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <p>Su contraseña ha sido actualizada correctamente.<br>Ahora puede volver a ingresar al sistema con su nueva contraseña.</p>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <router-link tag="a" class="btn btn-sm pull-right btn-success" to="/login">Ingresar</router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>


	</div>

</div>
</template>

<script>
import gql from 'graphql-tag'

import Navigation from '@/components/Navigation';
import Loader from '@/components/Loader';
import Password from 'vue-password-strength-meter'

export default {
    name: 'ForgotPassword',
    metaInfo: {
		title: 'Olvidé mi contraseña',
	},
    components: {
        Navigation,
        Loader,
        Password
    },
    data() {
        return {
            form:{
                passwordNew:'',
            },
            action:'send-code',
            hasChanges:false,
            loading:false,
            validationErrors:{},
            passwordStrength:0,
            showPassword:false,
            passwordFeedback:null
        }
    },
    beforeMount(){
        if( this.$route.query.code ){
            this.action = 'reset-password';
        }
    },
    methods:{
        showPasswordFeedback ({suggestions, warning}) {
            this.passwordFeedback = {suggestions, warning};  
        },
        passwordScore (score) {
            this.passwordStrength = score;
        },
        forgotPasswordSend(){
            var error=false;
            this.validationErrors = {};
            
            if( !this.form.email ){
                error=true;
                this.validationErrors['general'] = 'Ingrese su email';
            }

            if( !this.loading && !error){
                this.loading=true;

                this.$apollo.mutate({
                    mutation: gql`mutation ( $email:String! ){
                        userForgotPassword( email: $email) {
                            status
                            message
                        }
                    }`,
                    variables: {
                        email: this.form.email,
                    }
                })
                .then((data) => {
                    console.log('save control then ',data);
                    if(data.data.userForgotPassword.status != 200){
                        error=true;
                        this.validationErrors['general'] = data.data.userForgotPassword.message;
                    }else{
                        this.action='code-sended';
                    }
                    this.loading=false;
                    this.hasChanges = false;
                    this.form = {};
                })
                .catch(error => {
                    this.$toast.error('Oops!');
                    
                    let { graphQLErrors } = error;
                    if (graphQLErrors[0].extensions.category === "validation") {
                        this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                    }else{
                        this.validationErrors['general'] = graphQLErrors[0].debugMessage;
                    }
                    this.loading=false;
                })
            }
        },
        resetPasswordSend(){
            var error=false;
            this.validationErrors = {};
            
            if( this.passwordStrength <3 ){
                error=true;
            }
            if( this.form.passwordNew != this.form.passwordNewConfirm  ){
                error=true;
                this.validationErrors['data.passwordNewConfirm'] = 'Las contraseñas no coinciden';
            }

            if( !this.loading && !error){
                this.loading=true;
                var dataInput = {
                    token: this.$route.query.code,
                    password: this.form.passwordNew,
                    password_confirmation: this.form.passwordNewConfirm,
                };
                console.log('dataInput',dataInput);
                
                this.$apollo.mutate({
                    mutation: gql`mutation ( $data:NewPasswordWithCodeInput! ){
                        userUpdateForgottenPassword( data: $data) {
                            status
                            message
                        }
                    }`,
                    variables: {
                        data: dataInput,
                    }
                })
                .then((data) => {
                    if(data.data.userUpdateForgottenPassword.status != 200){
                        error=true;
                        this.validationErrors['resettingPasswordError'] = data.data.userUpdateForgottenPassword.message;
                    }else{
                        this.action='password-updated';
                    }
                    this.loading=false;
                    this.hasChanges = false;
                    
                })
                .catch(error => {
                    this.$toast.error('Oops!');
                    
                    let { graphQLErrors } = error;
                    if (graphQLErrors[0].extensions.category === "validation") {
                        this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                    }else{
                        this.validationErrors['general'] = graphQLErrors[0].debugMessage;
                    }
                    this.loading=false;
                })
            }
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
        },
    },
    beforeRouteLeave (to, from , next) {
        if(this.hasChanges ){
            const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios sin guardar!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next()
        }
    }
    
}
</script>

<style scoped>

</style>
